import Dashboard from './views/Dashboard'

const PromotionsRoutes = [
    {
        path: '/promotions',
        component: () => import(/* webpackChunkName: "promotions-module" */ './PromotionsModule.vue'),
        children: [
            { path: '', name: 'Promotions Dashboard', component: Dashboard },
            { path: 'promo-packs', name: 'Promo Packs', component: () => import(/* webpackChunkName: "promo-packs" */ './views/DistributorPromoPacks') },
            { path: 'email-blasts', name: 'Email Blasts', component: () => import(/* webpackChunkName: "email-blasts" */ './views/EmailBlasts') },
            { path: 'promo-codes', name: 'Promo Codes', component: () => import(/* webpackChunkName: "promo-codes" */ './views/PromoCodes') },
            { path: 'promo-code-detail/:promotion_id', name: 'Promo Code Detail', component: () => import(/* webpackChunkName: "promo-codes" */ './views/PromoCodes'), props: true }
        ]
    }
]

export default PromotionsRoutes
